angular.module('zc.projects')

.directive 'zcCartButtonEditor', (ProjectCartButton, Meta, BaseProjectCrudEditor) ->

  class CartButtonEditor extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality
      scope.cartButtonPageTypes = []

      Meta.getCartButtonPageTypes().then (res) ->
        scope.cartButtonPageTypes = res

  editor = new CartButtonEditor(
    ProjectCartButton
    Meta
    '/templates/projects.settings/initialization/cart_button_editor.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/initialization/cart_button_editor.directive.coffee